import { render, staticRenderFns } from "./FeatureTourSlides.vue?vue&type=template&id=6e0bd334&scoped=true&lang=html"
import script from "./FeatureTourSlides.vue?vue&type=script&lang=js"
export * from "./FeatureTourSlides.vue?vue&type=script&lang=js"
import style0 from "./FeatureTourSlides.vue?vue&type=style&index=0&id=6e0bd334&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0bd334",
  null
  
)

export default component.exports